import * as Constants from '../../constants';

export function closeDxLead(orderID, salesForceId) {
  fetch(`${Constants.MEDLIFE_LEAD_HOST[process.env.NODE_ENV]}`+`${Constants.apiMap.closeDxLead.endpoint}`, {
    crossDomain:true,
    method: Constants.apiMap.closeDxLead.method,
    headers: {
      'Content-Type': 'application/json',
      'X-Code': Constants.MEDLIFE_LEAD_X_CODE[process.env.NODE_ENV]
    },
    body: JSON.stringify({ orderId: orderID, sfId: salesForceId }),
    })
    .then(res => res.json())
    .then(response => {
      return response
    })
    .catch(error => {
      alert(`${error}. However, a new order has been successfully placed`);
      return error
    });
}